// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__gm-w-","body":"Layout_body__8qLxW"};